import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, getSessionToken, setSessionToken } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getSessionToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { user } = await api.get('/auth/me');
      setUser(user);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signInWithGoogle = useCallback(async (idToken) => {
    const { sessionToken, user } = await api.post('/auth/google', { idToken });
    setSessionToken(sessionToken);
    setUser(user);
    return user;
  }, []);

  const signOut = useCallback(() => {
    setSessionToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        signInWithGoogle,
        signOut,
        isAdmin: user?.role === 'admin',
        // Field/door-to-door rep (2026-09-21): the limited New Sign Up +
        // My QR Code view. Deliberately NOT "user?.role !== 'csr' &&
        // !isAdmin" -- role is always exactly one of rep/csr/admin/absent,
        // so checking it directly is less fragile if a role is ever added.
        isRep: user?.role === 'rep',
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
